import { createPortal } from 'react-dom';
import { Backdrop, CircularProgress } from '@mui/material';
import { Text } from '../';
import { BACKGROUND } from '../../Helpers/colors';

interface LoadingOverlayProps {
	color?: string;

	open: boolean;
	title?: string;
}

const LoadingOverlay = ({ open, title, color = BACKGROUND.PRIMARY[100] }: LoadingOverlayProps) => {
	if (!open) return null;

	return createPortal(
		<Backdrop
			sx={{
				color: '#fff',
				zIndex: 9999,
				background: 'rgba(30, 29, 29, 0.56)',
				backdropFilter: 'blur(4px)',
				display: 'flex',
				flexDirection: 'column',
				gap: '16px',
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
			}}
			open={open}
		>
			<CircularProgress size={60} sx={{ color }} />
			{title && <Text title={title} type="h6" fontWeight="semiBold" color={color} />}
		</Backdrop>,
		document.body,
	);
};

export default LoadingOverlay;
